import React, { useMemo } from 'react'
import useFavurTranslation from 'hooks/useFavurTranslation'
import { getBody, getTitle } from 'pages/Announcements/utils'
import { formatDate } from 'redesign/shared/date'
import { DATE_FORMAT_VARIANTS } from 'redesign/shared/date/constants'
import { newDateWithoutTime } from 'utils/date'
import ContentCard from '../content-card'
import type { AnnouncementCardProps } from './types'

const AnnouncementCard: React.FC<AnnouncementCardProps> = ({ announcement, onClick }) => {
  const { seen, insertedAt } = announcement
  const { t, locale, language } = useFavurTranslation()
  const title = useMemo(() => getTitle(announcement, language), [announcement, language])
  const subtitle = useMemo(() => getBody(announcement, language), [announcement, language])

  return (
    <ContentCard
      dataTestId="announcement-card"
      dotDataTestId="new-announcement"
      isNew={!seen}
      header={{
        title,
        subtitle,
        subtitleEndText: formatDate({
          date: newDateWithoutTime(insertedAt ?? ''),
          dateFormat: DATE_FORMAT_VARIANTS.shortWithoutWeekday,
          locale,
          t,
        }),
        subtitleOverflowSingleLine: true,
      }}
      onClick={onClick}
    />
  )
}

export default AnnouncementCard
